import { render } from "./SelectMomentsArtist.vue?vue&type=template&id=400f84b0"
import script from "./SelectMomentsArtist.vue?vue&type=script&lang=js"
export * from "./SelectMomentsArtist.vue?vue&type=script&lang=js"

import "./SelectMomentsArtist.vue?vue&type=style&index=0&id=400f84b0&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__